import TruckImage from '../../images/games/k2gender/truck.png';
import DollImage from '../../images/games/k2gender/doll.png';
import BoyDollImage from '../../images/games/k2gender/boy-doll.png';
import LegosImage from '../../images/games/k2gender/legos.png';
import TeddyBearImage from '../../images/games/k2gender/teddy-bear.png';

import TeacherImage from '../../images/games/k2gender/teacher.png';
import DoctorImage from '../../images/games/k2gender/doctor.png';
import NurseImage from '../../images/games/k2gender/nurse.png';
import HousekeeperImage from '../../images/games/k2gender/housekeeper.png';
import MechanicImage from '../../images/games/k2gender/mechanic.png'

import FootballplayerImage from '../../images/games/k2gender/footballplayer.png';
import BasketballplayerImage from '../../images/games/k2gender/basketballplayer.png';
import SwimmerImage from '../../images/games/k2gender/swimmer.png';
import GymnastImage from '../../images/games/k2gender/gymnast.png';
import RacecardriverImage from '../../images/games/k2gender/racecardriver.png';

import PinkImage from '../../images/games/k2gender/pink.png';
import BlueImage from '../../images/games/k2gender/blue.png';
import PurpleImage from '../../images/games/k2gender/purple.png';
import OrangeImage from '../../images/games/k2gender/orange.png';
import BlackImage from '../../images/games/k2gender/black.png';

import GardeningImage from '../../images/games/k2gender/gardening.png';
import DrawingImage from '../../images/games/k2gender/drawing.png';
import ReadingbooksImage from '../../images/games/k2gender/readingbooks.png';
import PlayingvideogamesImage from '../../images/games/k2gender/playingvideogames.png';
import BuildingwithblocksImage from '../../images/games/k2gender/buildingwithblocks.png';

import EggpdImage from '../../images/games/35gender/eggpd.png';
import CatpdImage from '../../images/games/35gender/catpd.png';
import EggstrImage from '../../images/games/35gender/eggstr.png';
import CatstrImage from '../../images/games/35gender/catstr.png';
import EggsprImage from '../../images/games/35gender/eggspr.png';
import CatsprImage from '../../images/games/35gender/catspr.png';
import EggImage from '../../images/games/35gender/egg.png';
import CatImage from '../../images/games/35gender/cat.png';

var question = ["truck", "doll", "boy-doll", "legos", "teddy-bear"];
var descr = ["Truck","Doll","Boy Doll","Building blocks","Teddy Bear"];
var biasFull = ["boy","girl","girl","boy","both"];
var biasNone = ["both","both","both","both","both"];
var topic = ["toy","job","occupation","color","hobby"];
var set = [];
var active = 1;
var fiveQ = 0;
var result = "Discussion";

var image_path_array = [TruckImage, DollImage, BoyDollImage, LegosImage, TeddyBearImage]

function changeDesc(x) {
	$("#desc").text("Who does the " + x + " belong to?");
};

function questions() {
	set = [];
	active = 1;
	changeDesc(topic[fiveQ])

	if(fiveQ == 1) {
		question = ["teacher", "doctor", "nurse", "housekeeper", "mechanic"];
		biasFull = ["both","boy","girl","girl","boy"];
		descr = ["Teacher","Doctor","Nurse","Housekeeper","Mechanic"];
		image_path_array = [TeacherImage, DoctorImage, NurseImage, HousekeeperImage, MechanicImage];

		$("#resDescThr").addClass("padding");
		$("#resDesc").text("Are there some jobs that are only for girls or only for boys?  Share your ideas.");
		$("#resDescTwo").text("When have you seen a boy doing a job that people sometimes think is for girls?");
		$("#resDescThr").text("When have you seen a girl doing a job that people sometimes think is for boys?");
	} else if(fiveQ == 2) {
		question = ["footballplayer","basketballplayer","swimmer","gymnast","racecardriver"];
		biasFull = ["boy","boy","both","girl","boy"];
		descr = ["Football Player","Basketball Player","Swimmer","Gymnast","Race Car Driver"];
		image_path_array = [FootballplayerImage, BasketballplayerImage, SwimmerImage, GymnastImage, RacecardriverImage];

		$(".qimg").show();
		$("#resDescTwo").removeClass("padding");
		$("#resDescThr").removeClass("padding");
		$("#resDesc").text("What do you think about these two pictures?");
		$("#resDescTwo").text("");
		$("#resDescThr").text("");
	} else if(fiveQ == 3) {
		question = ["pink","blue","purple","orange","black"];
		biasFull = ["girl","boy","girl","boy","both"];
		descr = ["Pink","Blue","Purple","Orange","Black"];
		image_path_array = [PinkImage, BlueImage, PurpleImage, OrangeImage, BlackImage];

		$(".qimg").hide();
		$("#resDescTwo").addClass("padding");
		$("#resDesc").text("Talk about your favorite color.  Is it okay to like a color that some people say is only for girls, or a boy color?");
		$("#resDescTwo").text("What would you do if a boy was teased for wearing pink?");
	} else if(fiveQ == 4) {
		question = ["gardening","drawing","readingbooks","playingvideogames","buildingwithblocks"];
		biasFull = ["girl","girl","girl","boy","both"];
		descr = ["Gardening","Drawing","Reading Books","Playing Video Games","Building with Blocks"];
		image_path_array = [GardeningImage, DrawingImage, ReadingbooksImage, PlayingvideogamesImage, BuildingwithblocksImage];

		$("#name").hide();
		$("#resDesc").text("Why might someone say that girls shouldn't play with blocks?");
		$("#resDescTwo").text("Are boys or girls better at playing video games?  Why or why not?");
	} else {
		question = ["truck", "doll", "boy-doll", "legos", "teddy-bear"];
		image_path_array = [TruckImage, DollImage, BoyDollImage, LegosImage, TeddyBearImage]
	}
	$("#picDiv img").attr("src", image_path_array[0]);
	$("#picDesc").text(descr[0]);
};

function nextImg() {
	$("#picDiv img").attr("src", image_path_array[active]);
	$("#picDesc").text(descr[active]);
	if(set.length == 5) {
		$("#mainGame").hide();
		$("#resMain").show();
		$(".avaChange").show();
		if (fiveQ < 3) {
			$("#egg").addClass("wiggle");
		} else if(fiveQ == 3) {
			$("#egg").addClass("wiggleFast");
		} else {
			$("#egg").removeClass("wiggleFast");
			$("#egg").removeClass("wiggle");
		}
		$(".avaChange").show();
		if(fiveQ == 1) {
			$("#resDescTwo").hide();
			$("#resDescThr").hide();
			$("#change1").text("Dot");
			$("#change2").text("Stripe");
			$("#change3").text("Spiral");
			$('p#avaDesc').text('Choose One');
		} else if(fiveQ == 2) {
			$("#discNext").hide();
			$("#next").show();
			$("#change1").text("Small");
			$("#change2").text("Medium");
			$("#change3").text("Large");
			$('p#avaDesc').text('Choose One');
		} else if(fiveQ == 3) {
			$("#resDescTwo").hide();
			$("#resDescThr").hide();
			$(".avaChange").hide();
			$("#avaClose").show();
			$("#name").show();
		} else if(fiveQ == 4) {
			$("#discNext").hide();
			$("#name").hide();
			$(".avaChange").hide();
			$("#avaClose").text("Click Next to see your creature!")
			$("#avaClose").show();
		} else {
			$('p#avaDesc').text('Choose One');
			$(".avaChange").show();
				$("#resDesc").show();
				$("#resDescTwo").hide();
				$("#resDescThr").hide();
		}

		$("#d").text(result);
		fiveQ++;
	}
	active++;
};
jQuery(function() {
	$('.gender-k2').on('click', "#dirPlay", function() {
    $("#mainDir").hide();
    $("#mainGame").show();
    $("#avaUI").show();
  })

  $('.gender-k2').on('click', ".genBtn", function() {
      var choice = $(this).attr('id');
      set.push(choice);
    //	$("#c").text(active);
    //	$("#b").text(set);
    //	$("#a").text(biasNone);
      nextImg();
      $("#active").text(active);
      if (fiveQ == 3) {
        $("#change4").hide();
      }
  });
  $('.gender-k2').on('click', "#discNext", function() {
    if(fiveQ == 1 || fiveQ == 4) {
      if($("#resDesc").is(':visible')) {
        $("#resDesc").hide();
        $("#resDescTwo").show();
        $("#discNext").hide();
        $("#next").show();
      }
    } else if(fiveQ == 2) {
      if($("#resDesc").is(':visible')) {
        $("#resDesc").hide();
        $("#resDescTwo").show();
      } else if($("#resDescTwo").is(':visible')) {
        $("#resDescTwo").hide();
        $("#resDescThr").show();
        $("#discNext").hide();
        $("#next").show();
      }
    }
  });
  $('.gender-k2').on('click', "#next", function() {
    $("#resMain").hide();
    $("#mainGame").show();
    $(".resDesc").show();
    $("#discNext").show();
    $("#picDesc").text(descr[active]);
    questions();
    $("#active").text(active);
    $(".avaChange").hide();
    $("#egg").removeClass("wiggle");
    $("#egg").removeClass("wiggleFast");
    if(fiveQ >= 5){
      $("#nameDisplay").text($("#name").val().replace("input=",''));
      $("#avaUI").hide();
      $("#egg").hide();
      $("#mainGame").hide();
      $("#fin").fadeIn();
      $("#eggCenter").fadeIn();
    }
    if(fiveQ == 1 || fiveQ == 2 || fiveQ == 3) {
      $("#next").hide();
    }
  });

  $('.gender-k2').on('click', ".avaChange", function() {
    $('p#avaDesc').text('Answer questions and watch it change!');
    if(fiveQ == 1) {
      if($(this).text() == "Red") {
        $(".egg").css("background","crimson");
      } else if($(this).text() == "Green") {
        $(".egg").css("background", "#33df47");
      } else if ($(this).text() == "Yellow"){
        $(".egg").css("background", "#f3f43c");
      } else {
        $(".egg").css("background", "#fff")
      }
    } else if(fiveQ == 2) {
      if($(this).text() == "Dot") {
        $("#egg").attr("src", EggpdImage);
        $("#eggDone").attr("src", CatpdImage);
        $(".egg").addClass("dot");
      } else if($(this).text() == "Stripe") {
        $("#egg").attr("src", EggstrImage);
        $("#eggDone").attr("src", CatstrImage);
        $(".egg").addClass("stripe");
      } else if($(this).text() == "Spiral") {
        $("#egg").attr("src", EggsprImage);
        $("#eggDone").attr("src", CatsprImage);
        $(".egg").addClass("spiral");
      } else {
        $("#egg").attr("src", EggImage);
        $("#eggDone").attr("src", CatImage);
        $(".egg").removeClass("dot");
        $(".egg").removeClass("stripe");
        $(".egg").removeClass("spiral");
      }
    } else if(fiveQ == 3) {
      if($(this).text() == "Small") {
        $(".egg").css("height", "150px");
        $(".egg").css("width", "150px");
        $(".eggDone").css("height", "150px");
        $(".eggDone").css("width", "150px");
      } else if($(this).text() == "Medium") {
        $(".egg").css("height", "200px");
        $(".egg").css("width", "200px");
        $(".eggDone").css("height", "200px");
        $(".eggDone").css("width", "200px");
      } else {
        $(".egg").css("height", "250px");
        $(".egg").css("width", "250px");
        $(".eggDone").css("height", "250px");
        $(".eggDone").css("width", "250px");
      }
    } else {
      $(".egg").css("background-color", "white");
    }
  })
});

